/**
 * Define um filtro que deve ser aplicado em uma consulta.
 *
 */
export class Filter {
    name: string;
    value: string;

    constructor(name: string, value: string) {
        this.name = name;
        this.value = value;
    }

    /**
     * Obtém o filtro em um formato de QueryStrig.
     *
     * @returns Filtro no formato de QueryString.
     */
    toQueryString(): string {
        return `${this.name}=${this.value}`;
    }
}

/**
 * Define um conjunto de filtros que podem ser aplicados em uma consulta.
 *
 */
export class Filters {
    private readonly filters: Filter[] = [];

    constructor(filters: Filter[] = []) {
        this.filters.push(...filters);
    }

    /**
     * Adiciona um filtro ao conjunto de filtros.
     *
     * @param name Nome do filtro.
     * @param value Valor do filtro.
     * @returns void
     */
    add(name: string, value: string): void {
        // Verifica se o filtro já existe e atualiza o valor, caso exista.
        const existingFilter = this.filters.find(
            (filter) => filter.name === name,
        );

        if (existingFilter) {
            existingFilter.value = value;
            return;
        }

        this.filters.push(new Filter(name, value));
    }

    /**
     * Obtém a quantidade de filtros aplicados.
     *
     * @return Número de filtros aplicados.
     */
    size(): number {
        return this.filters.length;
    }

    /**
     * Obtém os filtros em um formato de QueryString.
     *
     * @returns String representando os filtros no formato de QueryString.
     */
    toQueryString(): string {
        return this.filters.map((filter) => filter.toQueryString()).join('&');
    }
}
